<div class="container content-area">
  <div class="row">
    <div class="col-md-12">

      <h2 style="text-align: center" class="mt-40">IrvineTek Corporate Social Responsibility Policy</h2>
      <p>IrvineTek is an Irvine, CA based agile consulting and tech management firm that specializes in software and application development and consultation. It offers a wide range of services including design, development, delivery and maintenance of customized solutions as well as remote staffing services.</p>

      <h4>Policy brief & purpose</h4>
      <p>Our Corporate Social Responsibility (CSR) company policy refers to our responsibility toward our environment. Our company’s existence is not lonely. It's part of a bigger system of people, values, other organizations and nature. The social responsibility of a business is to give back to the world just as it gives to us.</p>

      <h4>What is corporate social responsibility?</h4>
      <p>Our Corporate Social Responsibility (CSR) company policy outlines our efforts to give back to the world as it gives to us.</p>

      <h4>Scope</h4>
      <p>This policy applies to our company and its subsidiaries. It may also refer to suppliers and partners.</p>

      <h4>Policy elements</h4>
      <p>We want to be a responsible business that meets the highest standards of ethics and professionalism.</p>
      <p>Our company’s social responsibility falls under two categories: compliance and proactiveness. Compliance refers to our company’s commitment to legality and willingness to observe community values. Proactiveness is every initiative to promote human rights, help communities and protect our natural environment.</p>

      <h5>1. Compliance</h5>
      <h5>Legality</h5>
      <p class="m-0">Our company will:</p>
      <ul>
        <li>Respect the law</li>
        <li>Honor its internal policies</li>
        <li>Ensure that all its business operations are legitimate</li>
        <li>Keep every partnership and collaboration open and transparent</li>
      </ul>

      <h5>Business ethics</h5>
      <p class="m-0">We'll always conduct business with integrity and respect to human rights. We'll promote:</p>
      <ul>
        <li>Safety and fair dealing</li>
        <li>Respect toward the consumer</li>
        <li>Anti-bribery and anti-corruption practices</li>
      </ul>


      <h5>2. Corporate Social Responsibility</h5>
      <h5>Protecting the environment</h5>
      <p>Our company recognizes the need to protect the natural environment. Keeping our environment clean and unpolluted is a benefit to all. We'll always follow best practices when disposing garbage and using chemical substances. Stewardship will also play an important role.</p>
      <h5>Protecting people</h5>
      <p class="m-0">We'll ensure that we:</p>
      <ul>
        <li>Don't risk the health and safety of our employees and community.</li>
        <li>Avoid harming the lives of local and indigenous people.</li>
        <li>Support diversity and inclusion.</li>
      </ul>
      <h5>Human rights</h5>
      <p>Our company is dedicated to protecting human rights. We are a committed equal opportunity employer (without any kind of discrimination against anyone based on gender, age, race etc.)  and will abide by all fair labor practices. We’ll ensure that our activities do not directly or indirectly violate human rights in any country (e.g. forced labor).</p>

      <h5>3. Proactiveness</h5>
      <h5>Donations and aid</h5>
      <p class="m-0">Our company may preserve a budget to make monetary donations. These donations will aim to:</p>
      <ul>
        <li>Advance the arts, education and community events.</li>
        <li>Alleviate those in need.</li>
      </ul>
      <h5>Volunteering</h5>
      <p>Our company will encourage its employees to volunteer. They can volunteer through programs organized internally or externally. Our company may sponsor volunteering events from other organizations.</p>
      <h5>Preserving the environment</h5>
      <p class="m-0">Apart from legal obligations, our company will proactively protect the environment. Examples of relevant activities include:</p>
      <ul>
        <li>Recycling</li>
        <li>Conserving energy</li>
        <li>Organizing reforestation excursions</li>
        <li>Using environmentally-friendly technologies</li>
      </ul>
      <h5>Supporting the community</h5>
      <p>Our company may initiate and support community investment and educational programs. For example, it may begin partnerships with vendors for constructing public buildings. It can provide support to nonprofit organizations or movements to promote cultural and economic development of global and local communities.</p>
      <h5>Learning</h5>
      <p>We will actively invest in R&D. We will be open to suggestions and listen carefully to ideas. Our company will try to continuously improve the way it operates.</p>
      <p>Our company is committed to the United Nations Global Compact. We'll readily act to promote our identity as a socially aware and responsible business. Management must communicate this policy on all levels. Managers are also responsible for resolving any CSR issues.</p>
      <p>Disclaimer: IrvineTek does not  assume any legal liability that may arise from the use of this policy.</p>

    </div>
  </div>
</div>
